import { Box, Button, CircularProgress, Divider, IconButton, Menu, MenuItem } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Approval, Send } from '@mui/icons-material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useState } from 'react';

export const getPayoutsColumns = ({ onView, onApprove, onSendPdf, loadingPdf }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };


  return [
    {
      headerName: 'Advisors ID',
      field: 'id',
      renderCell: row => <Box>{row.advisorId}</Box>,
    },
    {
      headerName: 'Advisors Name',
      field: 'name',
      renderCell: row => <Box>{row.name}</Box>,
    },
    {
      headerName: 'Total Payout',
      field: 'totalPayout',
      renderCell: row =>
        `£${row.totalPayout ? Number(row.totalPayout.toFixed(2)) : 0}`,
    },
    {
      headerName: 'Adjustment',
      field: 'adjustment',
      renderCell: row => `${row?.adjustments[0].name || 'N/A'}`,
    },
    {
      headerName: 'Adjustment Type',
      field: 'type',
      renderCell: row => `${row?.adjustments[0].type || 'N/A'}`,
    },
    {
      headerName: 'Frequency',
      field: 'frequency',
      renderCell: row => `${row?.adjustments[0].frequency || 'N/A'}`,
    },
    {
      headerName: 'Value',
      field: 'value',
      renderCell: row => `${row?.adjustments[0].value || 0}`,
    },
    {
      headerName: 'Net Payout',
      field: 'netPayout',
      renderCell: row =>
        `£${row.netPayout ? Number(row.netPayout.toFixed(2)) : 0}`,
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 120,
    },
    // {
    //   field: 'actions',
    //   headerName: 'Actions',
    //   width: 200,
    //   renderCell: (params) => (
    //     <>
    //       <Button
    //         onClick={() => onApprove(params.row)}
    //         disabled={params?.status === 'Paid'}
    //       >
    //         Approve
    //       </Button>
    //       <Button onClick={() => onView(params.row)}>
    //         View
    //       </Button>
    //     </>
    //   ),
    // },
    {
      headerName: 'Action',
      field: 'action',
      renderCell: params => (
        <>
          <IconButton onClick={event => handleMenuOpen(event, params)}>
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl) && selectedRow?.id === params.id}
            onClose={handleMenuClose}
            sx={{
              '& .MuiPaper-root': {
                borderRadius: '12px',
                backgroundColor: '#fff',
                boxShadow: 'none',
                minWidth: '120px',
                border: '1px solid rgba(0,0,0,0.1)',
              },
            }}
          >
            <MenuItem
              onClick={() => {
                onView(params);
                handleMenuClose();
              }}
              sx={{ display: 'flex', gap: '8px' }}
            >
              <VisibilityIcon fontSize="small" />
              View
            </MenuItem>
            <Divider />
            {/* {row.status == 'Pending' ? ( */}
            <MenuItem
              disabled={params?.status === 'Paid'}
              onClick={() => {
                onApprove(params)
                handleMenuClose();
              }}
              sx={{ display: 'flex', gap: '8px', color: 'orange' }}
            >
              <Approval fontSize="small" />
              Approve
            </MenuItem>
            {/* ) : (
              <MenuItem
                onClick={() => {
                  handleUnarchiveClick(row);
                  handleMenuClose();
                }}
                sx={{ display: 'flex', gap: '8px', color: 'green' }}
              >
                <Unarchive fontSize="small" />
                Unarchive
              </MenuItem>
            )} */}
            <Divider />
            <MenuItem
              variant="contained"
              size="small"
              sx={{ display: 'flex', gap: '8px' }}
              onClick={() => onSendPdf(params)}
              disabled={loadingPdf[params.id]} // Disable while loading
              startIcon={loadingPdf[params.id] ? <CircularProgress size={16} /> : null}
            >
              <Send />
              {loadingPdf[params.id] ? 'Sending' : 'Send'}
            </MenuItem>
          </Menu>
        </>
      ),
    },

  ];
};
